import { render, staticRenderFns } from "./NotTheSame.vue?vue&type=template&id=dcff6ecc&scoped=true&"
import script from "./NotTheSame.vue?vue&type=script&lang=js&"
export * from "./NotTheSame.vue?vue&type=script&lang=js&"
import style0 from "./NotTheSame.vue?vue&type=style&index=0&id=dcff6ecc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcff6ecc",
  null
  
)

export default component.exports